import React,{useState,useEffect,useContext} from 'react'
import {Card, Nav, Container, Row, Col, Spinner} from "react-bootstrap"
import { InputGroup, InputGroupAddon, Input } from 'reactstrap';
import { Table } from 'reactstrap';
import {CardTitle, CardText } from 'reactstrap';
import {SelectAllOutlined, EditOutlined,ArrowDownward, GetApp,History, Info, Close, CloudUpload, NavigateBefore, NavigateNext} from '@material-ui/icons';
import axios from "axios"
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import {UserContext} from "../Context/UserContext"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import { base_url } from '../../globalConstants';
import "./temp.css"
import Axios from "axios";
import { useHistory } from 'react-router-dom';

export default function List() {
 const EId=useContext(UserContext);
 const ezz = localStorage.getItem("ezzyid")
    //  console.log(" ezzyid fromlocal"+ezz)
    const [EzzId,SetEzzId]=useState(ezz);

    const [Details,setDetails]=useState([]);

    const [modal, setModal] = useState(false);
    const [modalViewDetails, setModalViewDetails] = useState(false);
    const [modalViewHistory, setModalViewHistory] = useState(false);
    const [Id,setId]=useState();
    const toggle = () => setModal(!modal);

    const [orderId, setOrderId] = useState('')
    const [previousPageUrl, setPreviousPageUrl] = useState('')
    const [nextPageUrl, setNextPageUrl] = useState('')
    const toggleUploadFileModal = (tempOrderId) => {
      setOrderId(tempOrderId)
      setModal(!modal);
    }
    const toggleViewDetails = () => setModalViewDetails(!modal);
    const toggleViewHistory = () => setModalViewHistory(!modal);
    const [OrderDetails, setOrderDetails] = useState({});
    const [OrderHistory, setOrderHistory] = useState({});
    const [image, setImage] = useState({upload_location:"",raw:""});
    const [showSpinner, setShowSpinner] = useState();
	const history = useHistory();
  
    const externalCloseBtn = <button className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={toggle}>&times;</button>;
    const fetchDetails=async()=>{
      // let token = localStorage.getItem("token")
      // var config = {
      //           headers: { 'Content-Type': 'multipart/form-data', 'Authorization': 'Token ' + token },

      //         }; 
      //   const response=await axios.get(base_url+`coupondetails/?search=&ezz_id=${ezz}`,config)
      //   const {data}=response;
      //   // console.log(data);
      //   setDetails(data.results);
      //   setPreviousPageUrl(data.previous);
      //   setNextPageUrl(data.next);

      let searchUrl = base_url+`coupondetails/?search=&ezz_id=${ezz}`   
      axios({
      method: 'GET',
      url: searchUrl
      }).then( async (response) =>{
      console.log('succ',response);
      const {data}=response;
      setDetails(data.results);
      setPreviousPageUrl(data.previous);
      setNextPageUrl(data.next);
      }).catch(  (response) =>{
      console.log('fail',response)

      })
    }
    useEffect(()=>{
        fetchDetails();
       
    },[])

              
  //   const [fileUrl, setFileUrl] = useState('')
  //   const [modalFile, setModalFile] = useState(false);
  //   const [open, setOpen] = useState(false);
  //   const [openFile, setOpenFile] = useState(false);

  //   const toggleFile = () => {
  //   setModal(!modalFile);
  //   setOpen(!openFile)
   
  // }

       const onHome = async () => {
		history.push('/customerdashboard');
	}
	
const handleKeyDownSearch=(e)=>{
  let searchUrl = base_url+`coupondetails/?search=${e.target.value}&ezz_id=${ezz}`   
  axios({
    method: 'GET',
    url: searchUrl
  }).then( async (response) =>{
    console.log('succ',response);
    const {data}=response;
    setDetails(data.results);
    setPreviousPageUrl(data.previous);
    setNextPageUrl(data.next);
  }).catch(  (response) =>{
    console.log('fail',response)
   
  })

}

  
const redemcoupon = async (keyid,ezzselected) => {
  //alert(order);
      var doc;
      var ezzid = ezzselected;
      var deleteid = keyid;
      console.log("pezz" + ezzid);
      console.log("deleid" + deleteid);
      var result = window.confirm("Are you sure want to redeem coupon!");
      if (result == true) {
          //doc = "OK was pressed.";
          let token = localStorage.getItem("token")
          const header = {
          'Content-Type': 'application/json',
          'Authorization': 'Token ' + token,

        }

        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();

        today = yyyy + '-' + mm + '-' + dd;
        //document.write(today);

        var formdata = new FormData()
        formdata.append("redeem_on", today)
        formdata.append("ezz_id", ezzid)
        formdata.append("status", 'Redeem')
        
        // let urlfordeletion = base_url+`coupondetails/${deleteid}/`
        // const response = await Axios.put(urlfordeletion,formdata,header)
      let searchUrl = base_url+`coupondetails/${deleteid}/`
      axios({
      method: 'PUT',
      url: searchUrl,
      data:formdata
      }).then( async (response) =>{
      console.log('succdeletion',response);
      // const {data}=response;
      // setDetails(data.results);
      // setPreviousPageUrl(data.previous);
      // setNextPageUrl(data.next);
      toast.info("Coupon redeem successfully!");
       fetchDetails();
      }).catch(  (response) =>{
      console.log('faildeletion',response)
      })

        //toast.info("Coupon redeem successfully!");
          //alert('Coupon redeem successfully!')
         
      } else {
          //doc = "Cancel was pressed.";
      }

}

const handleEditOption  = async (e) => {
     //alert(e)
     let selectedRowIndex ;
      e = e || window.event;
      var data = [];
      var target = e.srcElement || e.target;
      var deleteid;
      var ezzid;
      while (target && target.nodeName !== "TR") {
          target = target.parentNode;
          selectedRowIndex= target.sectionRowIndex
          console.log("Clicked row",target.sectionRowIndex)
      }
      if (target) {
          var cells = target.getElementsByTagName("td");
          deleteid = cells[8].innerHTML;
          ezzid = cells[0].innerHTML;
          // for (var i = 0; i < cells.length; i++) {
          //     data.push(cells[i].innerHTML);
          // }
      }

      var doc;
      var result = window.confirm("Are you sure want to redeem coupon!");
      if (result == true) {
          //doc = "OK was pressed.";
          let token = localStorage.getItem("token")
          const header = {
          'Content-Type': 'application/json',
          'Authorization': 'Token ' + token,

        }

        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();

        today = yyyy + '-' + mm + '-' + dd;
        //document.write(today);

        var formdata = new FormData()
        formdata.append("redeem_on", today)
        formdata.append("ezz_id", ezzid)
        formdata.append("status", 'Redeem')
        
        // let urlfordeletion = base_url+`coupondetails/${deleteid}/`
        // const response = await Axios.put(urlfordeletion,formdata,header)
      let searchUrl = base_url+`coupondetails/${deleteid}/`
      axios({
      method: 'PUT',
      url: searchUrl,
      data:formdata
      }).then( async (response) =>{
      console.log('succdeletion',response);
      // const {data}=response;
      // setDetails(data.results);
      // setPreviousPageUrl(data.previous);
      // setNextPageUrl(data.next);
      toast.info("Coupon redeem successfully!");
       fetchDetails();
      }).catch(  (response) =>{
      console.log('faildeletion',response)
      })

        //toast.info("Coupon redeem successfully!");
          //alert('Coupon redeem successfully!')
         
      } else {
          //doc = "Cancel was pressed.";
      }
      //alert(doc);
  }


   const updateOrderList = async (updatedUrl) => {

      setShowSpinner(true)
      let response_data = []
      var prevUrl 
      var nextUrl 
  
      await axios({
        method: "GET",
        url: updatedUrl
      }).then(function(response){
        setShowSpinner(false)
        // console.log("response",response);
        // console.log("response.data.results",response.data.results);
        response_data = response.data.results
        // context.setState({ updatedOrdersList: response.data.results })
        // console.log("UPDATED ORDELIST",this.state.updatedOrdersList);      
        console.log("UPDATED ORDELIST",response_data);   
        prevUrl = response.data.previous   
        nextUrl = response.data.next   

      }).catch(function(response){
        setShowSpinner(false)
        console.log("response",response);
        console.log("ERROR UPDATING ORDERLIST");
      })
  
      setDetails(response_data)
      setPreviousPageUrl(prevUrl)
      setNextPageUrl(nextUrl)
  
    }

    const handleCancel=()=>{
      setImage({upload_location:"", raw:""});
      setModal(!modal)
    }
    return (
        
        <div>
        <Row>
        <Col xs lg={9}>
			<br/><br/>
			{/*<h4 id="paymentreminder">Coupon List</h4> */}
			<h2 className="general-heading" >Coupon List</h2>
        </Col>
        <Col >
		<div style={{ margin: '10% 0', display: 'flex', flexDirection: 'row', gap: '10px' }}>
		<Button id="btnhome" className="btnCalculate" variant="primary" type='button' size='lg' block onClick= { onHome  }>Home</Button>  
                
        <InputGroup size="lg" >
        
        <Input name="insearch" placeholder="Search" onChange={handleKeyDownSearch}/>

      </InputGroup>
	  </div>
        </Col>
        </Row>
        <Row>
          <Col style={{ textAlign: 'center' }}>
            <div>
              {
                showSpinner
                  ?
                  < div className="center">

                    <Spinner animation="grow" variant="primary" size="sm" />
                    <Spinner animation="grow" variant="success" size="sm" />
                    <Spinner animation="grow" variant="warning" size="sm" />
                  </div>
                  :
                  null
              }
            </div>
          </Col>
        </Row>
        <Row><Col>
        <div style={{float:"left", paddingBottom: '5px'}}>
          {
            previousPageUrl
              ? <Button color="info" title="Previous Page" className="teal white-text mr-2" size="sm"
                  onClick={() => updateOrderList(previousPageUrl)} ><NavigateBefore /></Button>
              : <Button color="info" title="Previous Page" className="teal white-text mr-2" size="sm" disabled >
                  <NavigateBefore /></Button>
          }
          {
            nextPageUrl
              ? <Button color="info" title="Next Page" className="teal white-text mr-2" size="sm"
                  onClick={() => updateOrderList(nextPageUrl)}><NavigateNext /></Button>
              : <Button color="info" title="Next Page" className="teal white-text mr-2" size="sm" disabled>
                  <NavigateNext /></Button>
          }          
        </div>
        <div style={{float:"right"}}>
        
        </div>
</Col></Row>
        <Row>
          <Col xs={12} sm={12} lg={12}>
            <div >
              <Row id=" orderlistrow">
      <Col >S No.</Col>
      <Col style={{display:'none'}}>EzzId</Col>
	  
      {/*<Col>Amount(USD)</Col>*/}
      <Col >Status</Col>
      <Col >Action</Col>
      {/*<Col>Issued On</Col>
	  <Col>Valid Till</Col>
	  <Col>Status</Col>
	  <Col>Redeemed On</Col>
      <Col style={{display:'none'}}></Col>*/}
   </Row>
    </div>
  </Col>
  </Row>
  <Row>
          <Col xs={12} sm={12} lg={12}>
            <div >
    {Details.map((key,index)=>(
        <Row key={key.id}>
          <Col>
            <div className="orderlistwrapperdiv">
    <form>
        <Card key={key.id} className="orderItemdetailsCard">
            <Card.Header className="smallheader">
              <Row >
                <Col >
                  <Card.Text>{index+1}</Card.Text>
                </Col>
                <Col  style={{display:'none'}}>
                  <Card.Text>{key.ezz_id}</Card.Text>
                </Col>
               
                {/*<Col >
                  <Card.Text>{key.amount}</Card.Text>
                </Col>*/}
                <Col >
                  <Card.Text>{key.curr_status}</Card.Text>
                </Col>

                 {key.curr_status === 'New'
		?<Col> <Nav.Link className="orange-text modal-trigger " onClick={() => redemcoupon(key.id,key.ezz_id)}>Click to redeem</Nav.Link> </Col>
		:
    <Col></Col>
		}
              </Row>
            </Card.Header>


            <Card.Body>
				<Row>
					<Col>
						  <h6>Coupon Detail</h6>
						  Coupon Code: {key.coupon_code}<br></br>
              Amount(USD): {key.amount}<br></br>
                                          
					</Col>
          <Col>
              <br></br>
              Issued On: {key.created_on} <br></br>  
              Valid Till: {key.expired_on}<br></br>   
						  Redeemed On: {key.redeem_on}
						                          
					</Col>
				</Row>
			</Card.Body>
		</Card>
    </form>
 </div>
          </Col>
        {/*<th scope="row" >{index+1}</th>
        <td style={{display:'none'}} className="hide">{key.ezz_id}</td>
		{key.curr_status === 'New'
		?<td onClick={handleEditOption} ><a title = "Clcik to Redeem.." href="">Click to redeem..</a></td>
		:<td></td>
		}
        <td>{key.coupon_code}</td>
        <td>{key.amount}</td>
		<td>{key.created_on}</td>
		<td>{key.expired_on}</td>
		<td>{key.curr_status}</td>
		<td>{key.redeem_on}</td>
		<td style={{display:'none'}} className="hide">{key.id}</td>*/}
        </Row>
    ))}
  
 </div>
  </Col>
  </Row>

        </div>
     
    )
}
